import React from 'react';

export const ZoomIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36483_29457)">
        <path
          d="M4.6521 14.337C4.6521 14.6773 4.88647 14.9204 5.2146 14.9204H6.3396C6.62085 14.9204 6.9021 14.6773 6.9021 14.337V9.47591H11.5896C11.8708 9.47591 12.1521 9.23286 12.1521 8.89258V7.72591C12.1521 7.43424 11.8708 7.14258 11.5896 7.14258H5.7771C5.12085 7.14258 4.6521 7.6773 4.6521 8.30924V14.337ZM21.1521 7.72591V8.89258C21.1521 9.23286 21.3865 9.47591 21.7146 9.47591H26.4021V14.337C26.4021 14.6773 26.6365 14.9204 26.9646 14.9204H28.0896C28.3708 14.9204 28.6521 14.6773 28.6521 14.337V8.30924C28.6521 7.6773 28.1365 7.14258 27.5271 7.14258H21.7146C21.3865 7.14258 21.1521 7.43424 21.1521 7.72591ZM28.0896 18.0315H26.9646C26.6365 18.0315 26.4021 18.3231 26.4021 18.6148V23.4759H21.7146C21.3865 23.4759 21.1521 23.7676 21.1521 24.0592V25.2259C21.1521 25.5662 21.3865 25.8092 21.7146 25.8092H27.5271C28.1365 25.8092 28.6521 25.3231 28.6521 24.6426V18.6148C28.6521 18.3231 28.3708 18.0315 28.0896 18.0315ZM12.1521 25.2259V24.0592C12.1521 23.7676 11.8708 23.4759 11.5896 23.4759H6.9021V18.6148C6.9021 18.3231 6.62085 18.0315 6.3396 18.0315H5.2146C4.88647 18.0315 4.6521 18.3231 4.6521 18.6148V24.6426C4.6521 25.3231 5.12085 25.8092 5.7771 25.8092H11.5896C11.8708 25.8092 12.1521 25.5662 12.1521 25.2259Z"
          fill="#D9ECFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_36483_29457">
          <rect width="32" height="32" fill="white" transform="translate(0.6521 0.475586)" />
        </clipPath>
      </defs>
    </svg>
  );
};
